import DatatablesController from '../../../../datatables_controller';

export default class extends DatatablesController {
  datatableColumns() {
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'name',
        title: 'Pengguna',
        overflow: 'visible',
        autoHide: false,
        width: 200,
        template: function(data) {
          return `
            <div class="d-flex align-items-center">
              <div class="symbol symbol-40 flex-shrink-0 mr-3">
                <div class="symbol-label" style="background-image: url('${data.avatar_path}')"></div>
              </div>
              <div>
                <span class="font-weight-bolder d-block">${data.name || '-'}</span>
                <span class="text-muted font-size-sm">@${data.username || ''}</span>
              </div>
            </div>
          `;
        }
      },
      {
        field: 'reputation',
        title: 'Reputasi',
        overflow: 'visible',
        autoHide: false,
        width: 90,
        template: function(data) {
          return `<span class="font-weight-bolder text-success">${data.reputation}</span>`;
        }
      },
      {
        field: 'total_threads',
        title: 'Thread',
        overflow: 'visible',
        autoHide: false,
        width: 70,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.total_threads}</span>`;
        }
      },
      {
        field: 'flagged_count',
        title: 'Ditandai',
        sortable: false,
        overflow: 'visible',
        autoHide: false,
        width: 80,
        template: function(data) {
          if (data.flagged_count > 0) {
            return `<span class="badge badge-warning">${data.flagged_count}</span>`;
          }
          return `<span class="text-muted">0</span>`;
        }
      },
      {
        field: 'hidden_count',
        title: 'Disembunyikan',
        sortable: false,
        overflow: 'visible',
        autoHide: false,
        width: 110,
        template: function(data) {
          if (data.hidden_count > 0) {
            return `<span class="badge badge-danger">${data.hidden_count}</span>`;
          }
          return `<span class="text-muted">0</span>`;
        }
      },
      {
        field: 'Actions',
        title: 'Aksi',
        sortable: false,
        width: 80,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-clean btn-icon" href="${data.show_path}" title="Lihat Profil">
              <i class="fa fa-eye text-primary"></i>
            </a>
          `;
        }
      }
    ];
  }
}
